 export enum StudyAreaAccess {
     Private = 'Private',
     Shared = 'Shared',
     Revoke = 'Revoke',
 }
